import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getFeatureAll = (_params, onSuccess, onError) => {
    const response = axios.get('v1/admin/feature', { params: _params });
    return handleResponse(response, onSuccess, onError);
};

export const getFeatureBySubCategory = (id, onSuccess, onError) => {
    const response = axios.get(`v1/admin/feature/sub-category/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const getFeatureMappingBySubCat = (item, id, onSuccess, onError) => {
    const response = axios.get(`v1/admin/feature/${encodeURIComponent(item)}/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const createFeature = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/admin/feature`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const updateFeature = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/feature/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const softDeleteFeature = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/feature/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const deleteFeature = (id, onSuccess, onError) => {
    const response = axios.delete(`v1/admin/feature/${id}`);
    return handleResponse(response, onSuccess, onError);
};

// feature type
export const getFeatureTypeById = (id, onSuccess, onError) => {
    const response = axios.get(`v1/admin/feature-type/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const getFeatureTypeByFeature = (id, onSuccess, onError) => {
    const response = axios.get(`v1/admin/feature-type/feature/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const getFeatureAllType = (_params, onSuccess, onError) => {
    const response = axios.get('v1/admin/feature-type', { params: _params });
    return handleResponse(response, onSuccess, onError);
};

export const createFeatureType = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/admin/feature-type`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const updateFeatureType = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/feature-type/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const deleteFeatureType = (id, onSuccess, onError) => {
    const response = axios.delete(`v1/admin/feature-type/${id}`);
    return handleResponse(response, onSuccess, onError);
};